import React, { useState, useEffect } from 'react'
import { Typography, Box, Button, MenuItem, Menu } from '@mui/material'
import NavButton from './NavButtons'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { auth } from '../Firebase/utils'
import { emailSignIn, setUserProfileData } from '../Redux/User/user.actions';


const mapUserState = ({ user }) => ({
    currentUser: user.currentUser
})

const mapUserDataState = ({user}) => ({
    userProfileData: user.userProfileData
})

export default function FullAppBar( props ) {

    const [anchorElUser, setAnchorElUser] = useState(null);
    const [loginText, setLoginText] = useState('')
    const { currentUser } = useSelector(mapUserState)
    const { userProfileData } = useSelector(mapUserDataState)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    
      const handleCloseUserMenu = () => {
        setAnchorElUser(null);
      }

      const handleUserSignout = () => {
        auth.signOut()
        dispatch(setUserProfileData(null))
        dispatch(emailSignIn(null))
    }
    
      useEffect(() => {
        setLoginText(currentUser ? 'Logout' : 'Login')
      }, [currentUser])

  return (
    <>
            <Typography
                variant="h4"
                noWrap
                component="a"
                href="/"
                sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
                }}>
                    ZIA
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                <NavButton page={'Home'} clickHandler={() => navigate('/')} reference={props.props.appBarProps.getInvolvedRef}/>
                <NavButton page={'Resources'} clickHandler={() => navigate('/resources')} reference={props.props.appBarProps.getInvolvedRef}/>
                <NavButton page={'Meet Our Partners'} clickHandler={() => navigate('/partnerships')} reference={props.props.appBarProps.getInvolvedRef}/>
                <NavButton page={'Referrals'} clickHandler={() => navigate('/referrals')} reference={props.props.appBarProps.getInvolvedRef}/> 
                {currentUser && <NavButton page={'Community Square'} clickHandler={(() => navigate('/superchat'))}/>}
                {userProfileData && userProfileData.userRoles[0] === 'admin' && <NavButton page={'Admin'} clickHandler={(() => navigate('/admin'))} />}
                {userProfileData && userProfileData.userRoles[0] === 'stakeHolder' && <NavButton page={'Stakeholder Referals'} clickHandler={(() => navigate('/stakeholder-referal'))} />}
                {currentUser && <NavButton  page={'Private Chat'} clickHandler={(() => navigate('/private-chat'))}/>}
            </Box>
            <Box sx={{ flexGrow: 0 }}>
                    <Button style={{textDecoration:'none', color:'white'}} onClick={() => {currentUser ? handleUserSignout() : navigate(`/login`)}}><MenuItem>
                        <Typography textAlign="center" sx={{
                    mr: 2,
                    display: { xs: 'none', md: 'flex' },
                    fontFamily: 'monospace',
                    fontWeight: 700,
                    letterSpacing: '.3rem',
                    color: 'inherit',
                    textDecoration: 'none',
                    border:'3px solid white',
                    px:1,
                    py:0.5}}>{loginText.toUpperCase()}</Typography>
                    </MenuItem></Button>
                    <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                    >
                    </Menu>
                </Box>
    </>
  )
}
